import React from "react";
import { Box, Flex } from "@src/components/Boxes";
import { css } from "@emotion/react";
import Container from "@src/components/Container";
import styled from "@emotion/styled";
import Translate from "@src/components/translation/Translate";
import { graphql, useStaticQuery } from "gatsby";
import MarkedTranslate from "@src/components/translation/MarkedTranslate";

const Title = styled("h2")`
  font-size: 24px;
  font-weight: 800;
  line-height: 1em;
  margin-bottom: 0;
  margin-top: 22px;
`;

const Text = styled("p")`
  margin: 16px 0 11px;
  line-height: 1.42857143;

  a {
    background-color: transparent;
    color: #00bcf2;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: none;
      color: #00a8d9;
      outline: 0;
    }
  }
`;

const OpeningsSection = () => {
  const data = useStaticQuery(graphql`
    query {
      monster: file(name: { eq: "press-contact" }) {
        publicURL
      }
    }
  `);

  const { monster } = data;

  return (
    <Box
      css={css`
        background-color: #fff;
        color: #363636;
        padding-bottom: 0;
        border-top: 1px solid #e8e8e8;
      `}
    >
      <Container
        css={css`
          background-image: url(${monster.publicURL});
          background-repeat: no-repeat;
          background-position: bottom right;
        `}
      >
        <Flex alignItems="center" flexDirection="column" width={["66%"]} mx="auto" py="40px">
          {/*eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href=""
            id="contact-us"
            css={css`
              display: block;
              position: absolute;
              top: -88px;
              visibility: hidden;
              height: 0;
              line-height: 0;
            `}
          >
            <Translate path="directus.page_press.contact_title" />
          </a>
          <Title>
            <Translate path="directus.page_press.contact_title" />
          </Title>
          <Text>
            <MarkedTranslate path="directus.page_press.contact_text" />
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default OpeningsSection;
